import httpService from '@Utils/httpService';

const baseUrl = 'api/Facilities';

export default {
  get(params) {
    return httpService.get({
      url: baseUrl,
      params,
    });
  },
  typeHeadPerUser(params) {
    return httpService.get({
      url: baseUrl+'/typeHead/user',
      params,
    });
  },
  getByClient(params) {
    return httpService.get({
      url: `${baseUrl}/by-client`,
      params,
    });
  },
  getById(id) {
    return httpService.get({
      url: `${baseUrl}/${id}`,
    });
  },
  hasAccess(id) {
    return httpService.get({
      url: `${baseUrl}/has-access/${id}`,
    });
  },
  getGroupScope(id) {
    return httpService.get({
      url: `${baseUrl}/${id}/group-scope`,
    });
  },
  update(data) {
    if (!data.id) return this.add(data);
    return httpService.put({
      url: `${baseUrl}/${data.id}`,
      data,
    });
  },
  add(data) {
    return httpService.post({
      url: baseUrl,
      data,
    });
  },
  addToFav(id) {
    return httpService.post({
      url: baseUrl + `/favorite/${id}`,
    });
  },
  addToRecent(id) {
    return httpService.post({
      url: baseUrl + `/Recent/${id}`,
    });
  },
  delFav(id) {
    return httpService.delete({
      url: baseUrl + `/favorite/${id}`,
    });
  },
  del(id) {
    return httpService.delete({
      url: `${baseUrl}/${id}`,
    });
  },
  typeHead(params) {
    return httpService.get({
      url: `${baseUrl}/typeHead`,
      params,
    });
  },
};
